import type { Account } from '../types'
import * as React from 'react'

export const initialUserValue = {
  name: '...',
  email: '...',
  hasVerifiedEmail: false,
  helpScoutBeaconSignature: null,
  products: [],
  featureFlips: [],
  organizations: [],
  currentOrganization: {},
  isImpersonation: false,
  hellonextSsoToken: '',
}

export const UserContext = React.createContext<Account>(initialUserValue)

export function useUser(): Account {
  const user = React.useContext(UserContext)
  if (user === undefined) {
    throw new Error('useUser must be used within a UserContext.Provider')
  }

  return user
}
